import moment from 'moment';
import React, { FC } from 'react';
import styled from 'styled-components';
import { DateType } from 'api/models';
import { HumanisedDate } from 'components/atoms/humanised-date';
import { Caption01 } from 'components/styles';

const DatesWrapper = styled.span`
  > span {
    position: absolute;
    left: var(--layout-02);
    top: 4px;
    ${Caption01};

    &:last-child {
      left: auto;
      right: var(--layout-02);
    }
  }
`;

export const PhaseStatusProgressDates: FC<{
  className?: string;
  startDate: DateType;
  dueDate: DateType;
}> = ({ className, startDate, dueDate }) => {
  return (
    <DatesWrapper className={className}>
      <span>
        {startDate && <HumanisedDate timestamp={moment(startDate)} />}
      </span>
      <span>{dueDate && <HumanisedDate timestamp={moment(dueDate)} />}</span>
    </DatesWrapper>
  );
};
